module.exports = __webpack_public_path__ + "img/type10000.a30a086b.png";